import React from 'react';
import SystemEmailCreateComponent from '../../../components/Admin/emails/SystemEmailCreateComponent';
import { useNavigate } from 'react-router-dom';

const SystemEmailCreate = () => {
    const navigate = useNavigate();

    let redirect = (emailId) => {
        navigate(`/admin/system-email/edit/${emailId}`);
    }

    return <SystemEmailCreateComponent 	shouldRedirect={ (emailId) => redirect(emailId) } />;
}

export default SystemEmailCreate;